module.exports = __webpack_public_path__ + "static/16-5cfbad20615ce084220a0bbd9e2babaf.gif";